import clsx from "clsx";

type Props = {
  source: string;
  size?: "small" | "bigger" | "token" | "inputIcon" | "input";
  fallbackLetter?: string;
};

type Sizes = NonNullable<Props["size"]>;

const SizeMap: {
  [key in Sizes]: string;
} = {
  small: "h-[0.9375rem] w-[0.9375rem]",
  bigger: "h-[1.1875rem] w-[1.1875rem]",
  token: "h-[1.375rem] w-[1.375rem]",
  input: "h-[1.125rem] w-[1.125rem]",
  inputIcon: "h-[0.75rem] w-[0.75rem]",
};

const Avatar = ({ source, size = "small", fallbackLetter = "" }: Props) => {
  const sizeInPx = SizeMap[size];
  return (
    <div className={clsx(sizeInPx, "rounded-full")}>
      {source && source.length > 0 ? (
        <img src={source} alt="avatar" className="w-full h-full rounded-full" />
      ) : (
        <div className="w-full h-full bg-black rounded-full text-white flex justify-center items-center text-[0.5rem]">
          {fallbackLetter}
        </div>
      )}
    </div>
  );
};

export default Avatar;
